import type { RouteObject } from 'react-router';

import { PATHNAMES } from 'constants/constants';
import { lazyRoute } from 'utils/lazyRoute';

const InfringementDetectionHub = lazyRoute(
  () => import('pages/InfringementDetectionHub'),
  m => m.InfringementDetectionHub,
);
const InfringementDetectionResultsWrapper = lazyRoute(
  () => import('pages/InfringementDetectionResults/InfringementDetectionResultsWrapper'),
  m => m.InfringementDetectionResultsWrapper,
);
const InfringementDetectionStepsWrapper = lazyRoute(
  () => import('pages/InfringementDetectionSteps/InfringementDetectionStepsWrapper'),
  m => m.InfringementDetectionStepsWrapper,
);

export const infringementDetectionRoutes: RouteObject[] = [
  { path: PATHNAMES.infringementDetection, lazy: InfringementDetectionHub },
  { path: PATHNAMES.infringementDetectionNewSearch, lazy: InfringementDetectionResultsWrapper },
  { path: PATHNAMES.infringementDetectionSearch, lazy: InfringementDetectionStepsWrapper },
];
